import { TABBABLE_SELECTOR } from '../constants/tabbableSelector'

// the selector already keeps focusable elements only, so a tabindex attribute can just
// take an element out of the tab sequence
const isInTabSequence = (element: HTMLElement) => {
  const tabIndexAttribute = element.getAttribute('tabindex')

  if (tabIndexAttribute === null) {
    return true
  }

  return Number(tabIndexAttribute) >= 0
}

const isDisplayed = (element: Element, container: HTMLElement): boolean => {
  if (getComputedStyle(element).display === 'none') {
    return false
  }

  const { parentElement } = element

  if (!parentElement || element === container) {
    return true
  }

  return isDisplayed(parentElement, container)
}

export const getTabbableElements = (container: HTMLElement) => {
  const candidates = Array.from(container.querySelectorAll<HTMLElement>(TABBABLE_SELECTOR))

  return candidates.filter((candidate) => {
    if (!isInTabSequence(candidate)) {
      return false
    }

    if (candidate.closest('[disabled], [hidden], [inert]')) {
      return false
    }

    // visibility is inherited, so the computed value already covers hidden ancestors,
    // while display: none has to be looked up through the parent chain
    if (getComputedStyle(candidate).visibility === 'hidden') {
      return false
    }

    return isDisplayed(candidate, container)
  })
}
